'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import striptags from 'striptags';
import numeral from 'numeral';
import uniqid from 'uniqid';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Front';
import Slider from 'Components/Slider';
import { space as space_icons } from 'Components/IconsConfigs';
import { hybrid_space as hybrid_space_icons } from 'Components/IconsConfigs';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import FullScreenModal from 'Modals/FullScreenModal';
import PhotoIcon from 'Icons/PhotoIcon';
import FrontSpaceSchedule from 'Components/Front/FrontSpaceSchedule';
import EstablishmentMap from 'Components/Front/EstablishmentMap';
import CoworkingSpace from 'Components/Front/CoworkingSpace';
import SideWidget from 'Components/Front/SideWidget';
import Breadcrumb from 'Components/Front/Breadcrumb';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import truncate from 'Functions/truncate';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import { getSessionStorage, updateSessionStorage } from 'Functions/SessionStorage/frontPage';
import { getSpaceAmount, getMinMaxSeats, formatNum, isTrue } from 'Shared/utilities';
import { coworking_place_types } from 'Shared/options';
import { action, URL } from 'Shared/Routes';
const app = window.app;
const qwest = window.qwest;
const slider_modal_bemit = ['slider-fullscreen', 'simple'];
export default class FrontSpacePage extends Component {
  state = function () {
    const props = this.props;
    const TODAY = moment().format('YYYY-MM-DD');
    const state = {
      loading: true,
      pathname: document.location.pathname,
      people: window.localStorage.getItem('widget-people') || '',
      date: window.localStorage.getItem('widget-date') || TODAY,
      disposition: window.localStorage.getItem('widget-disposition') || '',
      start: '',
      end: '',
      pending_booking: window.localStorage.getItem('current_booking_id') ? true : false,
      modal: false,
      status_messages: {}
    };
    const establishment_pathname = document.location.pathname.slice(0, document.location.pathname.lastIndexOf('/'));
    const session_storage = document.location.pathname ? getSessionStorage({
      pathname: establishment_pathname
    }) : {};
    if (session_storage.date) state.date = session_storage.date;
    const is__date_expired = session_storage.date ? moment(session_storage.date).isBefore(TODAY, 'day') : false;
    if (is__date_expired) {
      state.date = TODAY;
      updateSessionStorage({
        pathname: establishment_pathname,
        date: TODAY
      });
    }
    return state;
  }.bind(this)();
  requests = {};
  availability_ref = React.createRef();
  modal_ref = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'UpdatedSideWidget',
      cb: component.handleWidgetChange
    });
    component.fetchData();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'UpdatedSideWidget',
      cb: component.handleWidgetChange
    });
    Object.keys(component.requests).forEach(name => component.requests[name]?.abort());
    component.requests = {};
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.pathname && prev_props.pathname !== document.location.pathname) {
      component.setState({
        pathname: document.location.pathname
      });
    }
  }
  handleWidgetChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.space?.id) return;
    if (state.pending_booking && window.localStorage.getItem('booking-space-id') !== state.space.id) {
      return;
    }
    if (state.pending_booking) {
      return component.setState({
        people: window.localStorage.getItem('widget-people'),
        date: window.localStorage.getItem('widget-date'),
        amount: window.localStorage.getItem('current_booking_price')
      });
    }
    const people = window.localStorage.getItem('widget-people');
    const date = window.localStorage.getItem('widget-date');
    component.setState({
      people: people,
      date: date
    });
    let amount = getSpaceAmount({
      pricings: state.space.pricings,
      disposition_seat: state.space.disposition_seat,
      schedule_price: state.space.schedule_price,
      space_type: state.space.type,
      people: people || state.people,
      date: date || state.date,
      start_hour: state.start,
      end_hour: state.end,
      roles: app?.state?.session?.user?.roles?.[0]
    });
    component.setState({
      amount: amount
    });
  };
  fetchData = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    let url = document.location.pathname;
    if (url.endsWith('/')) url = url.slice(0, -1);
    let etablishment_slug = url.slice(0, url.lastIndexOf('/'));
    etablishment_slug = etablishment_slug.slice(etablishment_slug.lastIndexOf('/') + 1);
    qwest.post(action('getAllFrontSpaces'), {
      slug: url.slice(url.lastIndexOf('/') + 1),
      etablishment_slug: etablishment_slug,
      striptags: false
    }).then(function (xhr, response) {
      moment.locale('fr');
      numeral.locale('en');
      component.need_availability = true;
      const space = response.data?.[0] || {};
      let meta_description = truncate(striptags(space.description), 160);
      if (meta_description.endsWith('...')) {
        meta_description = meta_description.slice(0, -3);
      }
      space.description = truncate(space.description, 160);
      space.min_max_seats = getMinMaxSeats(space);
      const title = [space.name, space._etablishment?.name || ''].filter(str => str).join(' / ');
      const metas = {
        title: title,
        description: meta_description
      };
      let slider_imgs;
      if (space.images?.length > 1) {
        slider_imgs = space.images.map(function (image) {
          let data = {
            alt: image.alt || image.title || title,
            src: variant({
              img: image,
              size: 1920,
              ratio: '16:9'
            }),
            id: uniqid()
          };
          return data;
        });
        Object.assign(metas, {
          og_image: slider_imgs[0].src,
          og_image_alt: slider_imgs[0].alt
        });
      }
      app.emit({
        event: 'setMetas',
        data: metas
      });
      let page_url = document.location.pathname;
      if (page_url.endsWith('/')) {
        page_url = page_url.slice(0, -1);
      }
      component.setState({
        id: space.id,
        etablishment_id: space._etablishment?.id,
        title: title,
        equipments: space.equipments || [],
        hybrid_equipments: space.hybrid_equipments || [],
        description: {
          __html: space.description || ''
        },
        space_type: coworking_place_types.find(opt => [opt.value, opt.new_value].includes(space.type)),
        images: space.images,
        slider_imgs: slider_imgs,
        background: space.images?.[0]?.url || undefined,
        schedule: space.schedule || {},
        loading: false,
        breadcrumb: [{
          name: 'home',
          url: URL('HomePage'),
          label: 'Accueil'
        }, {
          url: URL('FrontEtablishmentPage').replace(':slug', space._etablishment?.slug),
          label: space._etablishment?.name || 'Établissement myWO'
        }, {
          name: 'current-page',
          label: title,
          url: page_url
        }],
        space: space
      });
      app.emit({
        event: 'TCPageView',
        source: 'FrontSpacePage',
        data: {
          page: space._etablishment?.name || space.name,
          nom_espace: space.name,
          etablissement: space._etablishment?.name || 'etablissement',
          ville_reservation: space._etablishment?.address?.city
        }
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  openModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: true,
      modal_trg: e?.target
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trg: undefined
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const roles = app.state.session?.user?.roles || [];
    const is__b2b = roles.includes('company') || roles.includes('company_employee');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-transparent']
    }) : undefined;
    const equipments = space_icons.filter(infos => (state.equipments || []).includes(infos.value)).map(function (infos) {
      const Icon = infos.icon;
      const output = /*#__PURE__*/React.createElement("div", {
        className: "c-services-icons__item",
        key: infos.value
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "c-services-icons__svg"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-services-icons__label"
      }, infos.label || infos.value));
      return output;
    });
    const hybrid_equipments = hybrid_space_icons.filter(infos => (state.hybrid_equipments || []).includes(infos.value)).map(function (infos) {
      const Icon = infos.icon;
      const output = /*#__PURE__*/React.createElement("div", {
        className: "c-services-icons__item",
        key: infos.value
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "c-services-icons__svg"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-services-icons__label"
      }, infos.label || infos.value));
      return output;
    });
    const texts = /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__slider-texts"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, state.title), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__galerie"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "c-front-page-intro__btn",
      onClick: component.openModal
    }, /*#__PURE__*/React.createElement(PhotoIcon, {
      className: "c-front-page-intro__address-icon"
    }), "Galerie")));
    const picker_tool_modifiers = ['space-page'];
    if (state.date && moment().isSame(state.date, 'day')) {
      picker_tool_modifiers.push('tomorrow');
    } else if (!state.date) {
      picker_tool_modifiers.push('no-date');
    }
    const availability_modifiers = [];
    if (state.closed === true) availability_modifiers.push('closed');
    let booking_btn_disabled = false;
    if (state.space?.type === 'b_seminar') {
      booking_btn_disabled = !state.start || !state.disposition;
    } else {
      booking_btn_disabled = !state.start || !state.end || !state.people;
    }
    if (booking_btn_disabled === false && state.too_little_seats === true) {
      booking_btn_disabled = true;
    }
    if (state.space?.type === 'a_calm_coworking_space' && parseInt(state.space?.max_number_seat, 10) < parseInt(state.people, 10)) {
      booking_btn_disabled = true;
    }
    if (state.space?.type === 'b_seminar' && state.seminar_too_little_seats === true) {
      booking_btn_disabled = true;
    }
    if (state.people > 0 === false) {
      booking_btn_disabled = true;
    }
    const booking_btn_bemit = ['front', 'blue'];
    if (booking_btn_disabled) booking_btn_bemit.push('disabled');
    const free_conditions = isTrue(state.space?.custom_free_conditions) ? /*#__PURE__*/React.createElement("em", {
      className: "o-detailed-availability__special-txt"
    }, "Un forfait de consommations d\u2019un montant de ", formatNum(state.custom_free_price, '0,0[.]00'), "\xA0\u20AC vous sera demand\xE9 \xE0 l\u2019arriv\xE9e pour une demi-journ\xE9e. Il comprend\xA0: ", props.custom_free_text) : undefined;
    const availability = /*#__PURE__*/React.createElement("div", {
      className: "o-detailed-availability",
      ref: component.availability_ref
    }, is__b2b && state.space?.type === 'b_seminar' ? undefined : /*#__PURE__*/React.createElement("div", {
      className: "o-detailed-availability__heading"
    }, /*#__PURE__*/React.createElement("h2", {
      className: bemit('c-title', ['front'])
    }, "Disponibilit\xE9s"), free_conditions), is__b2b && state.space?.type === 'b_seminar' ? undefined : /*#__PURE__*/React.createElement("div", {
      className: "o-detailed-availability__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-media c-media--space-in-page"
    }, state.space?.id ? /*#__PURE__*/React.createElement(CoworkingSpace, _extends({}, state.space, {
      bemit: ['space', 'space-page'],
      "layout-type": "availability-only",
      availability: true,
      "space-infos-hidden": true,
      "init-from-props": true,
      date: state.date
    })) : undefined)));
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['space'])
    }, state.background ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Image, {
      className: "c-front-page-intro__bg",
      src: state.background,
      alt: 'Illustration ' + state.title
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__filter"
    })) : undefined, texts, loader), /*#__PURE__*/React.createElement("div", {
      className: "page-container u-positioned"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      links: state.breadcrumb
    }), state.id ? /*#__PURE__*/React.createElement(SideWidget, {
      space: state.space,
      "from-props": true,
      date: state.date
    }) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "widget-left-side"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-content u-margin-top-30"
    }, state.schedule && state.space_type ? /*#__PURE__*/React.createElement(FrontSpaceSchedule, _extends({}, state.schedule, {
      "space-type": state.space_type?.new_value
    })) : undefined, /*#__PURE__*/React.createElement("hr", {
      className: "o-separator"
    }), /*#__PURE__*/React.createElement("h2", {
      className: bemit('c-title', ['front-subtitle'])
    }, "\xC9quipements & Services"), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-services-icons', ['space'])
    }, equipments), hybrid_equipments.length > 0 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("hr", {
      className: "o-separator"
    }), /*#__PURE__*/React.createElement("h2", {
      className: bemit('c-title', ['front-subtitle'])
    }, "Espace hybride"), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-services-icons', ['space'])
    }, hybrid_equipments), /*#__PURE__*/React.createElement("hr", {
      className: "o-separator u-margin-top-20"
    })) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "front-space-description",
      dangerouslySetInnerHTML: state.description
    }), availability ? /*#__PURE__*/React.createElement("hr", {
      className: "o-separator"
    }) : undefined, availability ? availability : undefined), /*#__PURE__*/React.createElement("h2", {
      className: bemit('c-title', ['front-subtitle', 'gmap']),
      id: "map"
    }, "Carte"), state.etablishment_id ? /*#__PURE__*/React.createElement(EstablishmentMap, {
      id: state.etablishment_id
    }) : undefined)), /*#__PURE__*/React.createElement(FullScreenModal, {
      open: state.modal,
      onClose: component.closeModal,
      trigger_src: state.modal_trg,
      bemit: slider_modal_bemit
    }, state.background && state.images?.length > 1 === false ? /*#__PURE__*/React.createElement(Image, {
      className: "c-front-page-intro__bg",
      src: state.background,
      alt: 'Illustration ' + state.title
    }) : state.slider_imgs ? /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__slider-container"
    }, /*#__PURE__*/React.createElement(Slider, {
      images: state.slider_imgs,
      bemit: ['fill-height'],
      key: state.pathname,
      "with-overlay": true,
      "with-thumbnails": true,
      "with-imgs-title": true
    })) : undefined));
    return output;
  }
}
